import React from 'react';
import { Typography } from '@mui/material';
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';
import createStyles from '@mui/styles/createStyles';
import { OrderInfo } from 'common/types';
import { useTranslation } from 'services/localization';

interface Props {
	rentalInfo: OrderInfo;
}
const RentalCardBookingStatus = (props: Props) => {
	const classes = useStyles();
	const { rentalInfo } = props;
	const { t } = useTranslation();

	const failedLink =
		(rentalInfo.rentalLink &&
			rentalInfo.rentalLink.smsDeliveryStatusHistory &&
			rentalInfo.rentalLink.smsDeliveryStatusHistory.some((event) => event.status === 'failed') &&
			!rentalInfo.rentalLink.smsDeliveryStatusHistory.some(
				(event) => event.status === 'delivered',
			)) ||
		false;
	const delivered =
		rentalInfo.rentalLink &&
		rentalInfo.rentalLink.smsDeliveryStatusHistory &&
		rentalInfo.rentalLink.smsDeliveryStatusHistory.filter((event) => event.status === 'delivered');
	switch (rentalInfo.activeState) {
		case 'API_BOOKED':
			return (
				<>
					<Typography variant="body1" align="left" className={classes.marginTop8}>
						{t('individualRental.confirmed', 'Ready to start')}
					</Typography>
					<Typography variant="body2" color="textSecondary" align="left">
						{t('individualRental.api_booked.savedViaApi', 'Created via API')}
					</Typography>
				</>
			);
		case 'ADMIN_BOOKED':
			return (
				<>
					<Typography variant="body1" align="left" className={classes.marginTop8}>
						{t('individualRental.confirmed', 'Ready to start')}
					</Typography>
					<Typography variant="body2" color="textSecondary" align="left">
						{t('individualRental.admin_booked.savedViaAdmin', 'Via admin')}
					</Typography>
				</>
			);
		case 'PAYLINK_SENT':
			return failedLink ? (
				<>
					<Typography variant="body1" align="left" color="error" className={classes.marginTop8}>
						{t('individualRental.paylink_sent.failed', 'Rental link delivery failed!')}
					</Typography>
				</>
			) : (
				<>
					<Typography variant="body1" align="left" className={classes.marginTop8}>
						{t('individualRental.paylink_sent.pending', 'Pending')}
					</Typography>
					{delivered && delivered[0] && (
						<Typography variant="caption" align="left" color="textSecondary">
							{t('individualRental.paylink_sent.rentalLinkSent', {
								delivered: delivered[0].timestamp.slice(0, 10),
								defaultValue: 'Rental link sent {{delivered}}',
							})}
						</Typography>
					)}
				</>
			);
		case 'PAYLINK_CONFIRMED':
			return (
				<>
					<Typography variant="body1" align="left" className={classes.marginTop8}>
						{t('individualRental.confirmed', 'Ready to start')}
					</Typography>
					<Typography variant="body2" color="textSecondary" align="left">
						{t(
							'individualRental.paylink_confirmed.rentalLinkAcceptedNotPaid',
							'Accepted through rental link. Not paid.',
						)}
					</Typography>
				</>
			);
		case 'PAYLINK_PAID':
			return (
				<>
					<Typography variant="body1" align="left" className={classes.marginTop8}>
						{t('individualRental.confirmed', 'Ready to start')}
					</Typography>
					<Typography variant="body2" color="textSecondary" align="left">
						{t('individualRental.paylink_paid.rentalLinkPaid', 'Paid via rental link')}
					</Typography>
				</>
			);
		case 'STORE_BOOKED':
			return (
				<>
					<Typography variant="body1" align="left" className={classes.marginTop8}>
						{t('individualRental.confirmed', 'Ready to start')}
					</Typography>
					<Typography variant="body2" color="textSecondary" align="left">
						{t('individualRental.store_booked.checkIn', 'Via check-in')}
					</Typography>
				</>
			);
		case 'ONLINE_BOOKED':
			return (
				<>
					<Typography variant="body1" align="left" className={classes.marginTop8}>
						{t('individualRental.confirmed', 'Ready to start')}
					</Typography>
					<Typography variant="body2" color="textSecondary" align="left">
						{t('individualRental.online_booked.onlineBooked', 'Via online shop')}
					</Typography>
				</>
			);
		default:
			return null;
	}
};

const useStyles = makeStyles((theme: Theme) =>
	createStyles({
		marginTop8: {
			marginTop: theme.spacing(1),
			fontWeight: 500,
		},
	}),
);

export default RentalCardBookingStatus;
